import assetPath from '/app/xinglets/career-hub/bewerbung-topic-page/src/bewerbung-topic-page/cover-letter-section/assets/cover-letter-section-image.webp';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')